export const DELIVERY_FEE_PRESETS = [
  150, 200, 250, 299, 349, 399, 449, 499, 599, 699, 799, 899, 999, 1099,
] as const;

export const isPresetDeliveryFee = (value: number | string): boolean =>
  DELIVERY_FEE_PRESETS.includes(Number(value) as (typeof DELIVERY_FEE_PRESETS)[number]);
